import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { BroadcastingGalleryAddImageDialogComponent } from 'src/app/components/shared-components/broadcasting-gallery/broadcasting-gallery-add-image-dialog/broadcasting-gallery-add-image-dialog.component';
import { BroadcastingGalleryAddVideoDialogComponent } from 'src/app/components/shared-components/broadcasting-gallery/broadcasting-gallery-add-video-dialog/broadcasting-gallery-add-video-dialog.component';
import { BroadcastingGalleryZoomDialogComponent } from 'src/app/components/shared-components/broadcasting-gallery/broadcasting-gallery-zoom-dialog/broadcasting-gallery-zoom-dialog.component';
import { YoutubeCodeScrapperPipe } from 'src/app/pipes/youtube-code-scrapper/youtube-code-scrapper.pipe';

@Component({
  selector: 'app-broadcasting-gallery',
  templateUrl: './broadcasting-gallery.component.html',
  styleUrls: ['./broadcasting-gallery.component.scss']
})
export class BroadcastingGalleryComponent implements OnInit {

  @Input() gallery;
  @ViewChild('wrapcarousel', { static: false }) wrapcarousel: ElementRef;
  @ViewChild('itemcarousel', { static: false }) itemcarousel: ElementRef;
  @Output() outputEvent = new EventEmitter<any>();
  @Output() addOutputEvent = new EventEmitter<any>();
  public horizontalScrollValue: number;
  onInitPosition: boolean;
  onFinalPosition: boolean;
  showSpinner: boolean;
  video_id: string;

  constructor(private broadcastingsService: BroadcastingsService,
              private spinnerService: SpinnerService,
              private userStorageService: UserStorageService,
              private snackbarService: SnackBarService,
              private dialog: MatDialog,
              private youtubeCodeScrapperPipe: YoutubeCodeScrapperPipe) { }

  ngOnInit() {
    this.horizontalScrollValue = 0;
    this.onInitPosition = true;
    this.onFinalPosition = false;
  }

  public addImage() {
    const dialogRef = this.dialog.open(BroadcastingGalleryAddImageDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.gallery) {
          this.gallery.push(result);
          this.addOutputEvent.emit(result);
        } else {
          this.gallery = new Array();
          this.gallery.push(result);
          this.addOutputEvent.emit(result);
        }
      }
      this.outputEvent.emit(this.gallery);
    });
  }

  public addVideo() {
    const dialogRef = this.dialog.open(BroadcastingGalleryAddVideoDialogComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.gallery) {
          this.gallery.push(result);
          this.addOutputEvent.emit(result);
        } else {
          this.gallery = new Array();
          this.gallery.push(result);
          this.addOutputEvent.emit(result);
        }
      }
      this.outputEvent.emit(this.gallery);
    });
  }

  public zoom(item) {
    const dialogRef = this.dialog.open(BroadcastingGalleryZoomDialogComponent, { data: { item: item } });
  }

  public getYoutubeThumbnail(item) {
    if ((item.type.toLowerCase() === 'youtube') && (item.url)) {
      return 'http://img.youtube.com/vi/' + this.youtubeCodeScrapperPipe.transform(item.url) + '/0.jpg';
    }
  }

  public horizontalScroll() {
    return {
      transform: 'translateX(' + this.horizontalScrollValue + 'px)'
    };
  }

  public moveLeft() {
    if (this.horizontalScrollValue < 0) {
      this.onInitPosition = false;
      this.onFinalPosition = false;
      this.horizontalScrollValue += this.itemcarousel.nativeElement.getBoundingClientRect().width * 1;
    } else {
      this.onInitPosition = true;
    }
  }

  public moveRight() {
    if (this.horizontalScrollValue >= (this.wrapcarousel.nativeElement.scrollWidth - this.wrapcarousel.nativeElement.getBoundingClientRect().width) * (-1)) {
      this.onFinalPosition = false;
      this.onInitPosition = false;
      this.horizontalScrollValue -= this.itemcarousel.nativeElement.getBoundingClientRect().width * 1;
    } else {
      this.onFinalPosition = true;
    }
  }

  public galleryImagesLength() {
    return this.gallery.filter(
      (i) => {
        if (i.type === 'image') {
          return i;
        }
      }
    ).length;
  }

  public galleryVideosLength() {
    return this.gallery.filter(
      (i) => {
        if ((i.type === 'video') || (i.type === 'youtube')) {
          return i;
        }
      }
    ).length;
  }

  public deleteItem(item) {
    if (this.gallery.indexOf(item) !== -1) {
      this.gallery.splice(this.gallery.indexOf(item), 1);
    }
  }

}
